import { ChangeDetectionStrategy, Component } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { AssignmentSectionQuestionQuery } from '@examdojo/assignment';
import { QuestionSelectorItem, QuestionSelectorUiComponent } from '@examdojo/question';
import { ChallengeActivityQuestionStatusComponent } from '../question-selector/challenge-activity-question-status.component';
import { ChallengeReviewQuestionSelectorService } from './challenge-review-question-selector.service';

@Component({
  selector: 'dojo-challenge-review-question-selector',
  standalone: true,
  imports: [QuestionSelectorUiComponent, ChallengeActivityQuestionStatusComponent],
  template: `
    <ng-template #statusIndicator let-status>
      <dojo-challenge-activity-question-status [status]="status" class="mr-3" />
    </ng-template>

    <dojo-question-selector-ui
      [questions]="state.questions"
      [activeQuestionId]="state.activeQuestionId ?? null"
      [statusIndicatorTpl]="statusIndicator"
      (questionClick)="selectQuestion($event)"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChallengeReviewQuestionSelectorComponent {
  constructor(
    private readonly assignmentSectionQuestionQuery: AssignmentSectionQuestionQuery,
    private readonly challengeReviewQuestionSelectorService: ChallengeReviewQuestionSelectorService,
  ) {}

  readonly state = connectState({
    questions: this.challengeReviewQuestionSelectorService.questionsWithAttemptStatuses$,
    activeQuestionId: this.assignmentSectionQuestionQuery.activeQuestionId$,
  });

  selectQuestion(question: QuestionSelectorItem) {
    this.challengeReviewQuestionSelectorService.selectQuestion(question);
  }
}
